import React from 'react';
import PropTypes from 'prop-types';
import { Embed } from '../../Atoms';

const Video = ({ value }) => {
  if (!value) {
    console.warn('Video: Missing value');
    return null;
  }

  const { heading, subHeading, video, embed } = value;

  return (
    <section className="section section-full">
      <div className="section__inner">
        <div className="section__body">
          <div className="block">

            {(heading || subHeading) && (
              <div className="block__header text-center">
                {heading && <div className="text-section-title">{heading}</div>}
                {subHeading && <div className="text-section-support">{subHeading}</div>}
              </div>
            )}

            <div className="block__body">
              <div className="media-constrained">
                {video && video.url && (
                  <video
                    controls
                    autoPlay={video.autoplay}
                    loop={video.autoplay}
                    muted={video.autoplay}
                    className="video-element"
                  >
                    <source src={video.url} type={video.content_type || 'video/mp4'} />
                    Your browser does not support the video tag.
                  </video>
                )}
                {embed && <Embed value={embed} />}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

Video.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    video: PropTypes.shape({
      url: PropTypes.string,
      content_type: PropTypes.string,
      autoplay: PropTypes.bool,
    }),
    embed: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
};

export default Video;